import React from 'react';
import { connect } from 'react-redux';
import AddKeywordForm from '../../../../Components/Forms/Client/Keywords/AddKeyword';
import ModalsWrappedForm from '../../../../Components/Forms/ModalsWrappedForm';
import trans from '../../../../Translations/translation.service';
import { actions as allShortCodesActions } from '../../../../Redux/Api/AllShortCodes';
import { actions as keywordsActions, types } from '../../../../Redux/Api/Keywords';
import { PRIVATE_PATHS } from '../../../config';
import { FEMALE_CODE } from '../../../../Constants';
import { ADD_ACTIONS } from '../../../../Components/Forms/Admin/Keywords/config';
import { catchApiItemErrors } from '../../../../Helpers';

class AddKeyword extends React.Component {
  createKeyword = data => {
    return this.props.createKeyword(data).catch(
      catchApiItemErrors,
    );
  };

  loading = () => {
    const {
      isFetchingShortCodes,
      isCreatingKeyword,
    } = this.props;
    return isFetchingShortCodes
      || isCreatingKeyword;
  };

  parseShortCodes = () => (
    this.props.shortCodes.map(({ id: value, code: text }) => ({
      text, value,
    }))
  );

  componentDidMount() {
    this.props.fetchAllShortCodes({}, { query: { client: true } });
  }

  render() {
    const { history, success } = this.props;
    const shortCodes = this.parseShortCodes();
    const subject = trans('resources.singular.keyword');

    return (
      <ModalsWrappedForm
        gender={FEMALE_CODE}
        history={history}
        loading={this.loading()}
        open={success}
        path={PRIVATE_PATHS.clientKeywords.path}
        subject={subject}
        successMessage="successOpSingF"
        type="add"
      >
        <AddKeywordForm
          actions={ADD_ACTIONS}
          data={{
            short_code_id: shortCodes,
          }}
          history={history}
          loading={this.loading()}
          onSubmit={this.createKeyword}
          path={PRIVATE_PATHS.clientKeywords.path}
        />
      </ModalsWrappedForm>
    );
  }
}

const mapStateToProps = ({
  allShortCodes: {
    isFetching: isFetchingShortCodes,
    items: shortCodes,
  },
  keywords: { isCreating },
  reduxRestResponse: { body, success, type },
}) => ({
  body,
  isFetchingShortCodes,
  isCreatingKeyword: isCreating,
  shortCodes: shortCodes[1] ? shortCodes[1] : [],
  success: type === types.CREATE_KEYWORD && success,
});

export default connect(
  mapStateToProps,
  {
    ...allShortCodesActions,
    ...keywordsActions,
  }
)(AddKeyword);
